import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ExperienceView from '../views/ExperienceView.vue'
import MapView from '../views/MapView.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/experience', name: 'experience', component: ExperienceView },
    { path: '/map', name: 'map', component: MapView },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

export default router
